export default __webpack_public_path__ + "static/media/893.5113143c.png";